const UEProcessSection = () => (
  <section id="process">
    <div className="section-inner">
      <div className="section-head">
        <span className="section-label">
          <svg className="ico" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M3 12h14M13 6l6 6-6 6" />
          </svg>
          How it works
        </span>
        <h2 className="section-title">From &ldquo;Apply now&rdquo; to your first shift.</h2>
        <p className="section-lead">Four steps, usually wrapped up inside two weeks.</p>
      </div>

      <div className="steps-row">
        <div className="step">
          <div className="step-num">1</div>
          <div className="step-meta">A few minutes</div>
          <div className="step-title">Apply online</div>
          <p className="step-body">
            Select{' '}
            <strong style={{ fontSize: '1.05em' }}>Amsterdam, Groningen and Rotterdam</strong> as
            your city and complete your application.
          </p>
        </div>
        <div className="step">
          <div className="step-num">2</div>
          <div className="step-meta">Sign it off</div>
          <div className="step-title">Your Flink contract</div>
          <p className="step-body">
            Once your documents are checked and you&apos;re good to go, sign your Flink contract
            online.
          </p>
        </div>
        <div className="step">
          <div className="step-num">3</div>
          <div className="step-meta">Time to start</div>
          <div className="step-title">Onboarding day</div>
          <p className="step-body">
            We&apos;ll get in touch to schedule your onboarding shift, get you full gear and walk
            through the Uber Eats app.
          </p>
        </div>
        <div className="step">
          <div className="step-num">4</div>
          <div className="step-meta">You pick</div>
          <div className="step-title">First shift</div>
          <p className="step-body">
            Book your first shift in the Uber Eats app. Take orders, ride home with money in the
            bank that week.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default UEProcessSection;
